import { reportSteps, timeCommitments } from "@/mocks/site";

export default function ProcessSection() {
  return (
    <section className="w-full bg-foreground-950 text-background-100">
      <div className="w-full px-4 md:px-8 lg:px-12 py-14 md:py-20">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 text-xs font-medium tracking-[0.22em] text-primary-400 uppercase">
            <span className="w-6 h-px bg-primary-400" aria-hidden="true"></span>
            举报流程
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-background-50 text-balance">
            从提交线索到结果公示，四步走完
          </h2>
          <p className="mt-4 text-sm md:text-base leading-relaxed text-background-300">
            流程不绕弯，每一步都有明确的责任方与时间承诺。提交之后你会拿到受理编号，用来查询这条线索的全部进展。
          </p>
        </div>

        <ol className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-background-100/12 rounded-lg overflow-hidden border border-background-100/12">
          {reportSteps.map((item) => (
            <li key={item.step} className="bg-foreground-950 p-5 md:p-6">
              <span className="font-heading text-3xl md:text-4xl font-bold text-primary-400">{item.step}</span>
              <h3 className="mt-4 font-heading text-base md:text-lg font-bold text-background-50">{item.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-background-300">{item.desc}</p>
            </li>
          ))}
        </ol>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {timeCommitments.map((item) => (
            <div key={item.label} className="rounded-lg border border-background-100/15 p-5">
              <p className="text-xs tracking-wide text-background-400">{item.label}</p>
              <p className="mt-2 font-heading text-xl font-bold text-primary-400">{item.value}</p>
              <p className="mt-2 text-xs leading-relaxed text-background-300">{item.note}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}